import { sendServiceOrder } from '../services/order'
import { createOrderPayloadRequest } from '../types/models'

export const useSendOrder = (
  payload: createOrderPayloadRequest
): Promise<any> => {
  return sendServiceOrder(payload)
}
